// src/pages/Login.jsx
import React from "react";
import { useNavigate, Link } from "react-router-dom";
import GoogleIcon from '@mui/icons-material/Google';
import GitHubIcon from '@mui/icons-material/GitHub';
import Button from "@mui/material/Button";
import { authHelper } from "../Helpers/authHelper";
import "../styles/Auth.css";

export default function Login() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isGithubLoading, setIsGithubLoading] = React.useState(false);

  const handleLogin = async(e) => {
    setIsLoading(true);
    e.preventDefault();
    try {
      const helper = new authHelper();
      const userData = await helper.authenticateWithGoogle();
    

      console.log("User data:", userData);
      await checkUser(userData);
      // add success snackbar or toast notification here
    }catch(error) {
      console.error("Login failed:", error);
      navigate("/login");
    }finally {
      setIsLoading(false);
    }
  };

  const handleGithubLogin = async(e) => {
    setIsGithubLoading(true);
    e.preventDefault();
    try {
      const helper = new authHelper();
      const userData = await helper.authenticateWithGitHub();
      console.log("User data:", userData);
      await checkUser(userData);
      // add success snackbar or toast notification here
    }catch(error) {
      console.error("Login failed:", error);
      navigate("/login");
    }finally {
      setIsGithubLoading(false);
    }
  };

  async function checkUser(userData) {
     const userSaveData = await fetch(`${process.env.REACT_APP_BACKEND_URL}/user-sign-in`, {
       method: "POST",
       headers: {
         "Content-Type": "application/json",
       },
       body: JSON.stringify({
        userData: userData
     })
     });

      const result = userSaveData // optional: parse response
      if(!result.ok)
      {
        alert("User already present");
        navigate("/login");
        return;
      }
       navigate("/home");
  }

  return (
    <div className="auth-container">
      <Button
          color="primary"
          className={
            isLoading ? "google-login-button-disabled" : "google-login-button"
          }
          onClick={handleLogin}
          startIcon={<GoogleIcon />}
          variant="contained"
        >
          {isLoading ? "Signing up with Google..." : "Sign up with Google"}
        </Button>

        <Button
          color="primary"
          className={
            isGithubLoading ? "github-login-button-disabled" : "github-login-button"
          }
          onClick={handleGithubLogin}
          startIcon={<GitHubIcon />}
          variant="contained"
        >
          {isGithubLoading ? "Signing up with Github..." : "Sign up with Github"}
        </Button>
    </div>
  );
}
